<template>
	<page>
		<module title="满赠活动" enable-flex>
			<m-search ref="search" @search="searchHandle">
			    <m-search-item label="活动名称">
			    	<c-input name="activity_name" placeholder="模糊匹配"></c-input>
			    </m-search-item>
				<m-search-item label="秒杀状态" style="width:400px">
					<c-checkbox-group name="start_state" :options="activityState"></c-checkbox-group>
				</m-search-item>
			</m-search>
			
			<m-operate>
				<c-button v-if="auth('b_activity_gifts_edit')" color="sys" @click="navigateTo('/reward_gift_add')">新建活动</c-button>
			</m-operate>
			
			<c-table ref="table">

				<c-table-column
					label="活动状态"
					name="start_state"
					width="80"
				>
					<template v-slot="{data}">
						<span v-if="data.start_state == 0" style="color:#999">{{activityStateText[data.start_state]}}</span>
						<span v-if="data.start_state == 1" style="color:dodgerblue">{{activityStateText[data.start_state]}}</span>
						<span v-if="data.start_state == 2" style="color:#999">{{activityStateText[data.start_state]}}</span>
						<span v-if="data.start_state == 3" style="color:red">{{activityStateText[data.start_state]}}</span>
					</template>
				</c-table-column>

				<c-table-column
					label="活动名称"
					name="activity_name"
					width="200"
				></c-table-column>
		
				<c-table-column
					label="活动时间"
					width="300"
				>
					<template v-slot="{data}">{{data.begin_date}} 至 {{data.end_date}}</template>
				</c-table-column>
				
				<c-table-column
				    label="创建时间"
					width="140"
					name="create_date"
				>
				</c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="230"
				>
					<template v-slot="row">
						<c-table-button v-if="auth('b_activity_gifts_view')" @click="navigateTo(`/reward_gift_detail/${row.data.id}`)">查看</c-table-button>
                        <c-table-button v-if="auth('b_activity_gifts_edit') && row.data.state == 1 && row.data.start_state != 2" @click="navigateTo(`/reward_gift_edit/${row.data.id}`)">修改</c-table-button>
                        <c-table-button v-if="auth('b_activity_gifts_state') && row.data.state == 2 && row.data.start_state != 2" @click="changeActivityState(row,1)">暂停</c-table-button>
                        <c-table-button v-if="auth('b_activity_gifts_state') && row.data.state == 1 && row.data.start_state != 2" @click="changeActivityState(row,2)">开始</c-table-button>
                        <c-table-button v-if="auth('b_activity_gifts_edit') && (row.data.state == 1 || row.data.start_state == 2 || row.data.start_state == 3)" @click="deleteActivity(row)">删除</c-table-button>
						<c-table-button v-if="auth('b_activity_gifts_edit') && row.data.start_state != 2" @click="copyActivity(row)">复制</c-table-button>
          </template>
				</c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'm_activity_gifts',
		
		data() {
			return {
				activityState: [
					{name: '未开始',value: 0},
					{name: '进行中',value: 1},
					{name: '暂停中',value: 3},
					{name: '已结束',value: 2}
				]
			}
		},
		
		computed: {
			activityStateText() {
				var state = {};
				this.activityState.forEach(item => {
					state[item.value] = item.name;
				});
				
				return state;
			}
		},
		
		mounted() {
			this.$refs.search.search();
			this.$bus.$on('rewardGiftList.update', () => {
				this.$refs.search.search();
			});
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/activityGifts/list',
					data
				});
			},
			/**
				* 启禁用
				* @param item
				* @param state
			*/
			changeActivityState(item,state) {
				this.$confirm({
					title:'温馨提示',
					message: '确定要'+(state==2?"启用":"禁用")+'满赠活动【'+item.data.activity_name+'】吗？',
					resolve: () => {
						this.request({
							url: '/activityGifts/updateActivityState',
							data: {
								id: item.data.id,
								state:state
							},
							loading: true,
							success: () => {
								this.$message({
									type:'success',
									message: '禁用成功'
								});
								this.$refs.table.update();
							}
						});
					}
				});
			},
			
			deleteActivity(item) {
				this.$confirm({
					title:'温馨提示',
					message: '确定要删除此满赠活动【'+item.data.activity_name+'】吗？',
					resolve: () => {
						this.request({
							url: '/activityGifts/delete',
							data: {
								id: item.data.id
							},
							loading: true,
							success: () => {
								this.$message({
									type:'success',
									message: '删除成功'
								});
								this.$refs.table.update();
							}
						});
					}
				});
			},
			copyActivity(item) {
				this.request({
					url: '/activityGifts/copy',
					data: {
						id: item.data.id
					},
					loading: true,
					success: () => {
						this.$message({
							type:'success',
							message: '复制成功'
						});
						this.$refs.table.update();
					}
				});
			}
		}
	}
</script>